export default "__VITE_ASSET__DjDGeBG8__"